/**
 * @author: dwi.setiyadi@gmail.com
 */

import { RouterNonContainer, RouterContainer } from "./Router";
import ReduxReducer from "./ReduxReducer";
import HookReducer from "./HookReducer";
import ReduxPersist from "./ReduxPersist";
import ReduxSaga from "./ReduxSaga";
import { CompanyName, ProjectName, Layout, APIUri, APIKey } from "./App";

import {
  APIHOST,
  APIPORT,
  APIPROTOCOL,
  LDAP_SERVICE_BASIC_AUTH_PASSWORD,
  LDAP_SERVICE_BASIC_AUTH_USER,
  LDAP_SERVICE_HOST,
  LDAP_SERVICE_PORT,
  LDAP_SERVICE_PROTOCOL,
  MENU,
  APIHOSTLINTAS,
  APISERVICEPORT,
} from "./env";

import { initialAction, initialState } from "./Constants";

export {
  RouterNonContainer,
  RouterContainer,
  ReduxReducer,
  HookReducer,
  ReduxPersist,
  ReduxSaga,
  CompanyName,
  ProjectName,
  Layout,
  APIUri,
  APIKey,
  APIHOST,
  APIPORT,
  APIPROTOCOL,
  LDAP_SERVICE_BASIC_AUTH_PASSWORD,
  LDAP_SERVICE_BASIC_AUTH_USER,
  LDAP_SERVICE_HOST,
  LDAP_SERVICE_PORT,
  LDAP_SERVICE_PROTOCOL,
  MENU,
  APIHOSTLINTAS,
  APISERVICEPORT,
  initialAction,
  initialState,
};
